import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-status-label',
  templateUrl: './status-label.component.html',
  styleUrls: ['./status-label.component.scss'],
  standalone: true
})
export class StatusLabelComponent {

  @Input() text: string;
  @Input() color: string;

}
